import axios from "axios"
import Vue from "vue"
import VueCookies from 'vue-cookies'
import qs from 'qs';
import router from '../router/index'
import { Loading, Message } from 'element-ui';
var needLoadingRequestCount = 0;
axios.defaults.timeout = 10000;

window.location.href.indexOf("http://localhost")>-1? axios.defaults.baseURL = 'https://api.onesb2c.com/' :  axios.defaults.baseURL = window.serverAPI.url

axios.interceptors.request.use(
    config => {

        let token = VueCookies.get('token');
        let appToken =  VueCookies.get("appToken");
        // let token = sessionStorage.getItem("token");
        // let appToken = sessionStorage.getItem("appToken");


        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers.AppToken = `${appToken}`;
        }

        if (needLoadingRequestCount === 0) {
            Loading.service({ background: 'rgba(131, 143, 159, 0.3)' });
        }
        needLoadingRequestCount++;

        config.headers['Content-Type'] = 'application/json';

        return config;
    },
    error => {
        return Promise.reject();
    }
);

axios.interceptors.response.use(
    response => {
        if (needLoadingRequestCount <= 0) return;
        needLoadingRequestCount--;
        if (needLoadingRequestCount === 0) {
            Loading.service().close();
        }
        if (response.status === 200) {
            if (response.data.code == 0) {
                return response.data.result;
            } else if (response.data.code == -12) {
                //未登录
                Message({
                    type: "error",
                    message: "登录过期，请重新登录"
                })
                setTimeout(() => {
                    router.push({
                        path: "/login"
                    })
                }, 300)
            } else {
                Message({
                    type: "error",
                    message: response.data.msg
                })
            }

        } else {
            Promise.reject();
        }
    },
    error => {
        Loading.service().close();
        if (error.response.status == 401) {
            //未登录
            Message({
                type: "error",
                message: "登录过期，请重新登录"
            })
            setTimeout(() => {
                router.push({
                    path: "/login"
                })
            }, 300)
        }
    }
);

axios.post = function (url, data = {}) {

    return axios({
        method: 'post', // 请求协议
        url: url, // 请求的地址
        data: data, // post 请求的数据,很多人
        timeout: 15000, // 请求超时时间, 单位毫秒
    })
}

axios.get = function (url, params = {}) {
    return axios({
        method: 'get', // 请求协议
        url, // 请求的地址
        params, // get 请求的数据
        timeout: 60000 // 请求超时时间, 单位毫秒
    })
}

export default axios;
